import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

import { AgencyKnowledgeList } from '@frontend/features/agency-knowledge';

export function AgencyKnowledgeView() {
  // agencyId de la ruta /dashboard/agencies/:id/... (la agencia seleccionada),
  // no de CONFIG.AGENCY_ID.
  const { id } = useParams();

  return (
    <Box sx={{ p: 3 }}>
      <AgencyKnowledgeList agencyId={Number(id)} />
    </Box>
  );
}
